
import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createHashHistory } from 'history';
import Loadable from 'react-loadable';
import NotFound from '../pages/NotFound';
import Loading from '../components/Loading';

const browserHistory = createHashHistory();

const Panoramic = Loadable({
	loader: () => import(/* webpackChunkName: "panoramic" */'../pages/Panoramic'),
	loading: Loading,
});

const House = Loadable({
	loader: () => import(/* webpackChunkName: "house" */'../pages/House'),
	loading: Loading,
});

const Traffic = Loadable({
	loader: () => import(/* webpackChunkName: "traffic" */'../pages/Traffic'),
	loading: Loading,
});

const Map = Loadable({
	loader: () => import(/* webpackChunkName: "map" */'../pages/Map'),
	loading: Loading,
});

const Copyright = Loadable({
	loader: () => import(/* webpackChunkName: "copyright" */'../pages/Copyright'),
	loading: Loading,
});

const Sell = Loadable({
	loader: () => import(/* webpackChunkName: "sell" */'../pages/Sell'),
	loading: Loading,
});

class RouterConfig extends React.Component {

	render() {
		return (
			// <Router history={browserHistory}>
				<Switch>
					<Route exact path='/' component={Panoramic} />
					<Route path='/house' component={House} />
					<Route path='/traffic' component={Traffic} />
					<Route path='/map' component={Map} />
					<Route path='/sell' component={Sell} />
					<Route path='/copyright' component={Copyright} />
					<Route component={NotFound} />
				</Switch>
			// </Router>
		);
	}
}

export default RouterConfig;

